import { render, staticRenderFns } from "./comp6.vue?vue&type=template&id=4ead4c7b&scoped=true"
import script from "./comp6.vue?vue&type=script&lang=ts"
export * from "./comp6.vue?vue&type=script&lang=ts"
import style0 from "./comp6.vue?vue&type=style&index=0&id=4ead4c7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead4c7b",
  null
  
)

export default component.exports